import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { red, lightBlue, yellow, green } from "@material-ui/core/colors";
import { alpha } from "@material-ui/core/styles";
import clsx from "clsx";

const warningColor = yellow[200];

const useStyles = makeStyles((theme) => ({
  dot: {
    display: "inline-block",
    borderRadius: "50%"
  },

  warningDot: {
    backgroundColor: warningColor,
    boxShadow: `0 0 0 ${alpha(warningColor, 0.5)}`,
    animation: `$pulsing-warning 1500ms ${theme.transitions.easing.easeOut} infinite`
  },
  errorDot: {
    backgroundColor: red[500],
    boxShadow: `0 0 0 ${alpha(red[500], 0.5)}`,
    animation: `$pulsing-error 1500ms ${theme.transitions.easing.easeOut} infinite`
  },
  infoDot: {
    backgroundColor: lightBlue[500],
    boxShadow: `0 0 0 ${alpha(lightBlue[500], 0.5)}`,
    animation: `$pulsing-info 1500ms ${theme.transitions.easing.easeOut} infinite`
  },
  successDot: {
    backgroundColor: green[500],
    boxShadow: `0 0 0 ${alpha(green[500], 0.5)}`,
    animation: `$pulsing-success 1500ms ${theme.transitions.easing.easeOut} infinite`
  },

  "@keyframes pulsing-error": {
    "0%": { boxShadow: `0 0 0 0 ${alpha(red[500], 0.5)}` },
    "70%": { boxShadow: `0 0 0 8px ${alpha(red[500], 0.0)}` },
    "100%": { boxShadow: `0 0 0 0 ${alpha(red[500], 0.0)}` }
  },
  "@keyframes pulsing-warning": {
    "0%": { boxShadow: `0 0 0 0 ${alpha(warningColor, 0.5)}` },
    "70%": { boxShadow: `0 0 0 8px ${alpha(warningColor, 0.0)}` },
    "100%": { boxShadow: `0 0 0 0 ${alpha(warningColor, 0.0)}` }
  },
  "@keyframes pulsing-info": {
    "0%": { boxShadow: `0 0 0 0 ${alpha(lightBlue[500], 0.5)}` },
    "70%": { boxShadow: `0 0 0 8px ${alpha(lightBlue[500], 0.0)}` },
    "100%": { boxShadow: `0 0 0 0 ${alpha(lightBlue[500], 0.0)}` }
  },
  "@keyframes pulsing-success": {
    "0%": { boxShadow: `0 0 0 0 ${alpha(green[500], 0.5)}` },
    "70%": { boxShadow: `0 0 0 8px ${alpha(green[500], 0.0)}` },
    "100%": { boxShadow: `0 0 0 0 ${alpha(green[500], 0.0)}` }
  }
}));

const PulsingDot = ({ variant = "info", size = 10 }) => {
  const classes = useStyles();
  return (
    <span
      className={clsx(classes.dot, classes[`${variant}Dot`])}
      style={{ width: size, height: size }}
      aria-hidden="true"
    />
  );
};

export default PulsingDot;
